'use strict';
import Accordion from './accordions'
import DomUtils from "../helpers/dom-utils";

const additionalServicesSelector = '.additional-service-options';
const checkedServicesSelector = '.additional-service-options input[type="checkbox"]:checked';
const exclusionsSelector = '.additional-service-options-item__extra';

function init() {

  let controls = document.querySelectorAll('.additional-service-options-item .accordion-control');
  let redundantWrapper = document.querySelector('.additional-service-details');
  let checkedSelectedServices = document.querySelectorAll(checkedServicesSelector);

  if(checkedSelectedServices && checkedSelectedServices.length > 0) {
    const checkedSelectedServiceData = checkedSelectedServices[0].dataset;
    if(checkedSelectedServiceData) {
      const dialogueId = checkedSelectedServiceData.dialogueTarget;
      if(dialogueId) {
        const dialogue = document.querySelector(`[data-dialogue="${dialogueId}"]`);
        let exclusions =  document.querySelectorAll(exclusionsSelector);
        DomUtils.removeClass(dialogue, 'u-hidden');
        if(exclusions.length > 0) {
          DomUtils.addClass(exclusions[0], 'u-hidden');
        }
      }
    }
  }

  for (let control of controls) {
    let id = control.getAttribute('href');
    let element = document.querySelector(id);

    if (element) {
      element.classList.add('is-accordion');
      control.parentNode.appendChild(element.cloneNode(true));
    }
  }

  if (redundantWrapper) {
    redundantWrapper.parentNode.removeChild(redundantWrapper);
  }
  let additionalServiceDetails = document.querySelectorAll(additionalServicesSelector)
  for (let additionalServiceDetail of additionalServiceDetails) {
    new Accordion(additionalServiceDetail);
  }
  for (let tooltip of document.querySelectorAll('.additional-service-options-item-bottom')) {
    tooltip.classList.remove('u-hidden');
  }

  let warrantyCustomEnabled = false;
  const additionalService = document.querySelector(".additional-services")
  if (additionalService) {
    const additionalServiceData = additionalService.dataset;
    if(additionalServiceData) {
      warrantyCustomEnabled = additionalServiceData.warrantyCustomEnabled == 'true';
    }
  }

  if(!warrantyCustomEnabled) {
    for (let additionalServiceDetail of additionalServiceDetails) {
      let additionalServiceItems = additionalServiceDetail.querySelectorAll('.additional-service-options-item');
      for (let additionalServiceItem of additionalServiceItems) {
        let checkbox = additionalServiceItem.querySelector('.additional-service-options-item-top input');
        let tooltip = additionalServiceItem.querySelector('.additional-service-options-item-top .button-tooltip');
        let tooltipContent = additionalServiceItem.querySelector('.additional-service-options-item-bottom .tooltip-content');
        if (checkbox) {
          checkbox.addEventListener('change', function() {
            if(this.checked && tooltipContent && tooltipContent.classList.contains('is-closed')) {
              tooltip.click();
            }
          });
        }
      }
    }
  }
}

if ('querySelector' in document && document.querySelector(additionalServicesSelector)) {
  init();
}

export default {
  init
}
